/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/latinfusion/"

const latinFusion: CommunityData = {
  code: "latinfusion",
  inviteCode: "latinfusion",
  name: "Latin Fusion",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/lat-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmo001v8w00009kmomw7ilrod.jpg?uploadTime=1776278583155&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[41px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f7f690",
      asideBg: "#f76d42",
      asideStyles: "!p-0 !gap-0 border-r border-[#d5d5d5]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: ``,
      bgMobile: ``,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['FuturaLTProBook']",
      primaryButton:
        "bg-[#7f55e6] border border-[#7f55e6] rounded-full px-[18px] py-[18px] gap-y-[6px] text-[#111111] font-['FuturaLTProSemiBold'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#f7f690",
      sideBarSeparator: "border-r-[1px] border-[#d5d5d5]",
      separator: "border-[#d5d5d5]",
      item: "font-['FuturaLTProSemiBold'] text-[15px] text-[#f7f690] uppercase leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#d5d5d5] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    comingSoon: {
      bgColor: "#F7F690",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#F7F690]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[130px]",
      },
      werzLogoColor: "#191818",
      title: "font-['FuturaLTProBold'] text-[28px] leading-[120%] text-[#000000]",
      text: "font-['FuturaLTProBook'] text-[16px] leading-[120%] text-[#222222]",
      button:
        "font-['FuturaLTProSemiBold'] text-[14px] leading-[120%] uppercase p-4 rounded-full bg-[#7f55e6] text-[#111111] cursor-pointer w-fit",
      input: {
        base: "font-['FuturaLTProBook'] text-[14px] leading-[120%] w-[256px] rounded-[8px] px-4 h-[48px] bg-white",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['FuturaLTProBook'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['FuturaLTProBook'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton:
        "font-['FuturaLTProBook'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      modal: {
        container: "bg-[#f0f0f0] px-[40px] py-[48px]",
        title: "font-['FuturaLTProBold'] text-[24px] leading-[120%] text-[#000000] text-center",
        text: "font-['FuturaLTProBook'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-black bg-white font-['FuturaLTProBook'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    communityLanding: {
      container: "!bg-[#ffffff] !pb-8",
      titles:
        "text-[#000000] font-['FuturaLTProBold'] text-[24px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['FuturaLTProBold'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['FuturaLTProBold'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['FuturaLTProBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['FuturaLTProBold'] text-[24px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile: "",
      bgColor: "#f7f690",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#f7f690] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#d5d5d5] object-cover",
        name: "text-[#ffffff] font-['FuturaLTProBold'] text-[24px] uppercase text-center leading-[110%] mt-4 mb-1",
        location:
          "text-[#ffffff] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-2",
        description:
          "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#d5d5d5] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#ffffff] text-[#222222] font-['FuturaLTProBook'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center rounded-2xl",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#ffffff] flex flex-col justify-center items-center p-[34px] mb-[32px] rounded-2xl",
          title:
            "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-1",
          text: "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-center leading-[120%]",
          button:
            "bg-[#d5d5d5] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#ffffff] rounded-2xl flex justify-between",
          duration: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          name: "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "rounded-xl overflow-hidden m-2",
        },
        event: {
          container: "bg-[#ffffff] overflow-hidden sm:w-[500px] w-[95vw] rounded-2xl",
          name: "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase text-left leading-[110%] mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] bg-[#7f55e6] rounded-2xl text-[#111111] flex flex-col justify-center items-center gap-1 font-['FuturaLTProBold'] text-[14px] uppercase",
          duration: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          location: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          button:
            "bg-[#d5d5d5] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] border-t border-[#d5d5d5] px-4 py-3 flex justify-between gap-4",
            name: "text-[#000000] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#8d8d8d] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
            link: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
            status:
              "text-[#8d8d8d] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
            button:
              "bg-[#d5d5d5] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#ffffff] text-[#222222] font-['FuturaLTProBook'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center rounded-2xl",
        header:
          "text-[#ffffff] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#ffffff] sm:w-[500px] w-[95vw] rounded-2xl flex justify-between",
          name: "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          media: "rounded-xl overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] bg-[#ffffff] text-[#222222] font-['FuturaLTProBook'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center rounded-2xl",
        header:
          "text-[#ffffff] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#ffffff] sm:w-[500px] w-[95vw] rounded-2xl flex justify-between",
          coverUrl: "rounded-xl overflow-hidden m-2",
          duration: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          liveType: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          liveTypeCircle: "w-2 h-2 bg-[#7f55e6] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#7f55e6",
          playIconBorderColor: "#000000",
          start: "text-[#8d8d8d] font-['FuturaLTProBook'] text-[12px] text-left leading-[120%]",
          title:
            "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#222222] font-['FuturaLTProBook'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#ffffff] text-[#222222] font-['FuturaLTProBook'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center rounded-2xl",
        header:
          "text-[#ffffff] font-['FuturaLTProBold'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#ffffff] w-[95vw] rounded-2xl flex justify-between",
          name: "text-[#000000] font-['FuturaLTProBold'] text-[16px] uppercase leading-[110%]",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#d5d5d5] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#000000] font-['FuturaLTProBook'] text-[12px] text-center leading-[120%]",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#d5d5d5]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['FuturaLTProBold'] text-[24px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#8d8d8d] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#7f55e6] border border-[#7f55e6] rounded-full px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#111111] font-['FuturaLTProSemiBold'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['FuturaLTProBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['FuturaLTProBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['FuturaLTProBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['FuturaLTProBold'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#d5d5d5] border border-[#ffffff00] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#d5d5d5] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#8d8d8d] font-['FuturaLTProBook'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#8d8d8d] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#8d8d8d] font-['FuturaLTProBold'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#d5d5d5] border border-[#ffffff00] rounded-full px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#d5d5d5] border border-[#ffffff00] rounded-full px-[16px] py-[12px] text-[#000000] font-['FuturaLTProSemiBold'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default latinFusion
